export class PropertyValuePair {

  propertyName: string;

  propertyValue: any;
}
